import { render, staticRenderFns } from "./page-header.vue?vue&type=template&id=2297aafa&scoped=true"
import script from "./page-header.vue?vue&type=script&lang=ts"
export * from "./page-header.vue?vue&type=script&lang=ts"
import style0 from "./page-header.vue?vue&type=style&index=0&id=2297aafa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2297aafa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2297aafa')) {
      api.createRecord('2297aafa', component.options)
    } else {
      api.reload('2297aafa', component.options)
    }
    module.hot.accept("./page-header.vue?vue&type=template&id=2297aafa&scoped=true", function () {
      api.rerender('2297aafa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/ui/page-header/page-header.vue"
export default component.exports